/* Pfeile fuer die Stimmen-Reihe.

   Liegt bewusst als eigene Datei hier und nicht in der Section:
   sections/ak-voices-2026.liquid kam im September sechsmal in Folge
   nicht im Shop an, ohne dass Shopify je einen Grund genannt haette.
   Seither bekommt die Datei nur, was sie unbedingt braucht.

   Die Reihe scrollt auch ohne dieses Skript - mit dem Rollrad, mit dem
   Trackpad und mit dem Finger. Die Knoepfe sind die Zugabe fuer die
   Maus. Faellt das Skript aus, bleiben sie stehen und tun nichts; das
   ist der Grund, warum die vierte Karte immer angeschnitten hereinragt.
*/
(function () {
  'use strict';

  function reduced() {
    return window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function init(rail) {
    var strip = rail.querySelector('[data-ak-rail-strip]');
    var prev = rail.querySelector('[data-ak-rail-prev]');
    var next = rail.querySelector('[data-ak-rail-next]');
    if (!strip || !prev || !next || rail.dataset.akRailReady) return;
    rail.dataset.akRailReady = '1';

    /* Eine Karte plus ihr Abstand. Wird bei jedem Klick neu gemessen,
       damit ein Breitenwechsel nicht zu halben Spruengen fuehrt. */
    function step() {
      var card = strip.firstElementChild;
      if (!card) return strip.clientWidth;
      var gap = parseFloat(getComputedStyle(strip).columnGap);
      if (isNaN(gap)) gap = 0;
      return card.getBoundingClientRect().width + gap;
    }

    function nudge(dir) {
      strip.scrollBy({
        left: dir * step(),
        behavior: reduced() ? 'auto' : 'smooth'
      });
    }

    function sync() {
      var rest = strip.scrollWidth - strip.clientWidth - strip.scrollLeft;
      prev.disabled = strip.scrollLeft <= 1;
      next.disabled = rest <= 1;
    }

    prev.addEventListener('click', function () { nudge(-1); });
    next.addEventListener('click', function () { nudge(1); });
    strip.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function boot(root) {
    var rails = (root || document).querySelectorAll('[data-ak-rail]');
    for (var i = 0; i < rails.length; i++) init(rails[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* Im Theme-Editor wird die Section neu gezeichnet, ohne dass die
     Seite neu laedt. */
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
